module.exports = __webpack_public_path__ + "img/rank2.cc616746.png";